import { Typography } from 'antd';
import { FC } from 'react';

import { SearchConsoleUrlInspection } from '@/modules/DomainsApi';

interface Props {
  crawledAs: NonNullable<SearchConsoleUrlInspection['indexStatusResult']>['crawledAs'] | null
}

export const CrawlingUserAgentLabel: FC<Props> = ({ crawledAs }) => {
  if (crawledAs) {
    if (crawledAs === 'CRAWLING_USER_AGENT_UNSPECIFIED') {
      return <span>Невизначений пошуковий робот</span>;
    }
    if (crawledAs === 'DESKTOP') {
      return <span>Пошуковий робот Googlebot для комп’ютерів</span>;
    }
    if (crawledAs === 'MOBILE') {
      return <span>Пошуковий робот Googlebot для смартфонів</span>;
    }
  } else {
    return <Typography.Text>(недоступно)</Typography.Text>;
  }
};
